// @flow

import { PureComponent } from '../../helpers/pure-components'; import { setHasVoted, hasVoted as getHasVoted } from './helpers/cookieUtils'
import { createVote } from './helpers/createVote'
import { registerVote } from '../../db/registerVote'

import type { Alternative, Poll, Vote, AuthConfig } from '../../types'
import type { WithVotingStateRenderProps } from './types'

type Props = {
  clientId: number,
  poll: Poll,
  authConfig: AuthConfig,
  render: (props: WithVotingStateRenderProps) =>?any
}

type State = {
  hasVoted?: ?boolean,
  error?: ?Error,
  vote?: ?Vote,
  isDisplayVoteConfirmedMessage?: ?boolean
}

export class WithVotingState extends PureComponent<Props, State> {
  constructor (props: Props) {
    super(props)
    const { poll } = props
    const hasVoted = getHasVoted(poll.id)
    this.state = {
      hasVoted
    }
  }

  componentWillReceiveProps (nextProps: Props) {
    const isNewPoll = this.props.poll.id !== nextProps.poll.id
    if (isNewPoll) {
      const hasVoted = getHasVoted(nextProps.poll.id)
      this.setState({
        hasVoted
      })
    }
  }

  handleRegisterVote = async (alternative: Alternative) => {
    const { clientId, poll, authConfig } = this.props
    const vote = createVote(clientId, poll, alternative)
    this.setState({
      hasVoted: true,
      vote: vote,
      error: null
    })
    try {
      await registerVote(vote, authConfig)

      // when vote has been registered, it is safe to set a cookie that
      // tells the browser that the user has registered a vote for this poll
      setHasVoted(poll.id, alternative.id)

      // Facilitate the display of a 'vote confirmed' message to screen readers when vote has
      // been registered. Remove / disable it after it has been picked up by the screen reader
      this.setState(
        {
          isDisplayVoteConfirmedMessage: true
        },
        () => {
          setTimeout(() => {
            this.setState({
              isDisplayVoteConfirmedMessage: false
            })
          }, 2000)
        }
      )
    } catch (error) {
      const errorMessage = 'Unable to register vote'
      console.error(errorMessage)
      this.setState({
        hasVoted: false,
        vote: null,
        error: new Error(errorMessage)
      })
    }
  }

  render () {
    return this.props.render({
      ...this.state,
      onRegisterVote: this.handleRegisterVote
    })
  }
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/WithVotingState.js